import * as Migration from 'shared/migration/migration';
import { AccountType } from 'shared/types/flowstep';


const conversions = [
    {
        version: '0',
        isSuitableObject: user => user.version == null || user.version === '0',
        rules: []
    },
    {
        version: '1',
        isSuitableObject: (user) => {
            return !!user.old_data;
        },
        rules: [{
            isSuitable: (user, isMigratingUp) => {
                if (isMigratingUp) {
                    return !!user.profile;
                }
                return !!user.old_data;
            },
            migrateUp: v0tov1,
            migrateDown: v1tov0,
        }]
    },
];

export const CURRENT_VERSION = '1';

export function migrateToTheLatest(userOrUsers) {
    const users = Array.isArray(userOrUsers) ? userOrUsers : [userOrUsers];
    return Migration.migrateToTheLatest(users, conversions);
}

function v0tov1(user) {
    return {
        username: user.username,
        email: user.email,
        license: user.license,
        loginData: {
            username: user.username,
            accountType: AccountType.SF,
            sfMode: user.profile.mode,
            token: user.token,
        },
        settings: user.settings,
        sfData: user.profile,
        sf_api: user.sf_api,
        slackData: user.slack ? {} : undefined,
        version: CURRENT_VERSION,
        old_data: user
    };
}

function v1tov0(user) {
    //only for SF users
    return { ...user.old_data, token: user.loginData.token };
}
